import { get, getTrackingString } from '../../utils/object-helpers';
import storeEvent from '../../utils/store-event';

export default class {
    onCreate(input) {
        this.model = input;
    }
    onInput(input) {
        this.model = input;
        return {
            listingId: input.listingId,
            label: get(input, 'moreOptions.textSpans.0.text', ''),
            itemTitle: get(input, 'title.textSpans.0.text', ''),
            tracking: getTrackingString(input, 'moreOptions.action.trackingList'),
            renderBody: input.renderBody,
            classAttr: input.classAttr
        };
    }
    onClickOpen(evt) {
        if (evt.originalEvent) {
            evt.originalEvent.preventDefault();
        }
        storeEvent.openQuickview.dispatch({ ...this.model });
    }
    onKeyupOpen(evt) {
        if (evt.key && evt.keyCode === 13) {
            storeEvent.openQuickview.dispatch({ ...this.model });
        }
    }
}
